import { Stack } from "@mui/material";
import LegendBullet from "components/chart/LegendBullet";
import { formatNumberBasedOnUser } from "utils/namesManipulation";

import type { EnergyAnalysisCategoryTotal } from "../model/types";

type EnergyAnalysisKpiChartProps = {
  items: EnergyAnalysisCategoryTotal[];
  unit: string;
};

export const EnergyAnalysisKpiChart = ({ items, unit }: EnergyAnalysisKpiChartProps) => (
  <Stack className="h-[26rem] w-full min-h-0 flex-col overflow-auto px-4">
    {items.map((item) => (
      <Stack className="w-full min-w-0 shrink-0 justify-between gap-4 py-1" key={item.key}>
        <Stack className="min-w-0 gap-2">
          <LegendBullet color={item.color} height="1.2rem" type="circle" width="1.2rem" />
          <span className="min-w-0 font-ds-body-semibold-sm text-lds-foreground-primary">{item.label}</span>
        </Stack>
        <span className="shrink-0 text-lds-foreground-muted font-ds-body-bold-md">
          {formatNumberBasedOnUser(item.value, 2)} {unit}
        </span>
      </Stack>
    ))}
  </Stack>
);
